// The Main Draw and the Points tab name a knockout round by its distance from the final.
export const roundsToFinal = ({ stage, finalStage } = {}) =>
  Number.isSafeInteger(stage) && Number.isSafeInteger(finalStage) && finalStage >= stage
    ? finalStage - stage
    : null

const roundLabel = distance =>
  ({ 0: "Final", 1: "Semifinals", 2: "Quarterfinals" })[distance] ||
  `Round of ${2 ** (distance + 1)}`

export default roundLabel
